import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PaymentResultShell from './PaginasMP/PaymentResultShell';
import './PaginasMP/PaginasMP.css';

/**
 * Página mostrada después de enviar un pedido (flujo sin MercadoPago).
 * Recibe orderNumber por location.state al redirigir desde el carrito.
 */
const OrderConfirmed = () => {
  const location = useLocation();
  const orderNumber = location.state?.orderNumber;

  useEffect(() => {
    document.title = orderNumber
      ? `Pedido #${orderNumber} enviado · Privistore`
      : 'Pedido enviado · Privistore';
    return () => {
      document.title = 'Privistore';
    };
  }, [orderNumber]);

  const subtitle = orderNumber
    ? `Tu pedido #${orderNumber} fue enviado correctamente. Te contactaremos a la brevedad para coordinar el pago y la entrega. Guardá este número por si necesitás consultar.`
    : 'Tu pedido fue recibido. Te contactaremos a la brevedad para coordinar el pago y la entrega.';

  return (
    <PaymentResultShell
      variant="success"
      title="Pedido enviado"
      subtitle={subtitle}
      primaryLabel="Ir al inicio"
      primaryTo="/"
      secondaryLabel="Seguir comprando"
      secondaryTo="/productos"
    />
  );
};

export default OrderConfirmed;
